import { useLang } from '@/i18n';
import EcoBundleEarlyBird from './eco-bundle-early-bird';
import { EcoBundleEarlyBirdItemProps } from 'eco-design/sections/eco-bundle-early-bird/type';
import { useRouter } from 'next/router';
import useWssEarlyBird from '../../../../../compCommon/hooks/UseWssEarlyBird';
import { activityIdMap } from './config';
import styles from './index.module.scss';
import { PRODUCT_OBJ } from './product_list';

export default function Comp() {
    const { t } = useLang('theProduct.bundles');
    const { locale = 'us' } = useRouter();
    const bundles: EcoBundleEarlyBirdItemProps[] = [
        {
            desc: [t('item1_desc1')],
        },
        {
            desc: [t('item2_desc1')],
        },
        {
            desc: [t('item3_desc1')],
        },
        {
            desc: [t('item4_desc1')],
        },
        {
            desc: [t('item5_desc1')],
        },
        {
            desc: [t('item6_desc1')],
        },
    ].map((item, idx) => ({ ...item, ids: PRODUCT_OBJ[locale as 'us'][idx] }));

    const { items, onCountdownEnd } = useWssEarlyBird(activityIdMap[locale as 'us'] || activityIdMap.us, bundles) || bundles;

    console.log('items', items);

    return (
        <div className={styles.comp}>
            <EcoBundleEarlyBird items={items} onCountdownEnd={onCountdownEnd} />
        </div>
    );
}
